<!-- 任务列表 -->
<template>
  <div class="basicStyle">
    <div class="initialLogin" v-if="allProgressData.is_bank_check == 1">
      <div class="initialLeft">
        <img
          src="../../assets/new/tj_a2.png"
          alt=""
          style="
            vertical-align: middle;
            width: 20px;
            height: 20px;
            margin-top: -3px;
            margin-right: 10px;
          "
        />
        请尽快完成收款账号确认，否则将影响正常结算
      </div>
      <div class="initialRight" @click="goConfirm">去确认</div>
    </div>
    <div class="bg_fff">
      <div>
        <el-row>
          <el-col :span="8">
            <div class="grid-content bg-purple flex-box item_a1">
              <div class="initialNum">{{ allProgressData.nofee }}</div>
              <div>
                可结算（元）

                <el-button type="primary" size="mini" @click="goConfirm"
                  >结算流程
                  <i class="el-icon-question" style="margin-left: 10px"></i>
                </el-button>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple flex-box item_a2">
              <div class="initialNum">
                {{ allProgressData.fee }}
              </div>
              <div>已结算（元）</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple flex-box item_a3">
              <div class="initialNum">{{ allProgressData.total_amount }}</div>
              <div>
                累计收益总额(元)

                <el-popover placement="top-start" width="300" trigger="hover">
                  <div
                    v-html="jsjyguljsy_text"
                    style="white-space: pre-line"
                  ></div>
                  <i class="el-icon--right questionIcon" slot="reference"></i>
                </el-popover>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="table">
        <el-table :data="tableList" stripe style="width: 100%" border>
          <el-table-column label="结算周期" align="center" width="200">
            <template slot-scope="scope">
              {{ scope.row.start_at }}至{{ scope.row.end_at }}
            </template>
          </el-table-column>
          <el-table-column
            prop="group_tc_money"
            label="周期内订单分成总额"
            align="center"
          />
          <el-table-column
            prop="refund_money"
            label="退款扣除金额"
            align="center"
          />
          <el-table-column prop="fee" label="实际结算金额" align="center" />
          <el-table-column label="结算状态" align="center">
            <template slot-scope="scope">
              {{ statusMap.get(scope.row.status) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[10, 30, 50, 80]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryInfo.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import commonApi from "@/api/common";
import { clearObj, deepClone } from "@/utils";
import TableComponents from "@/components/TableComponents.vue";
import MyButton from "@/components/MyButton.vue";
// 结算
export default {
  name: "tobSettlement",
  components: { MyButton },
  data() {
    return {
      loading: false,
      queryInfo: {
        limit: 10,
        page: 1,
        total: 0,
      },
      tableList: [],
      timeFrame: [],
      selfnumzbsm: "",
      allProgressData: {},
      statusOptions: [
        // 结算状态 0待结算 1可结算 2 已结算
        { value: 0, label: "待结算" },
        { value: 1, label: "可结算" },
        { value: 2, label: "已结算" },
      ],
      jsjyguljsy_text: "",
    };
  },
  computed: {
    statusMap() {
      return new Map(
        this.statusOptions.map((item) => [item.value, item.label])
      );
    },
  },
  created() {
    // this.getMe();
    // this.getTobAllTask();
    this.getDic();
    this.queryTable();
  },
  methods: {
    goConfirm() {
      // 去确认
      this.$router.push({
        path: "/settlementProcess",
      });
    },
    // async getMe() {
    //   const res = await commonApi.tobMe();
    //   if (res.code === 200) {
    //     this.role = res.data.role;
    //   }
    // },
    viewDetails(row) {
      console.log("viewDetails", row);
      if (row.username == "juheng") {
        this.$router.push({
          path: "/callPhone",
        });
      } else {
        this.$router.push({
          path: "/callPhone",
          query: {
            staff_id: row.id,
            type: 2,
            task_id: this.queryInfo.task_id ? this.queryInfo.task_id : "",
          },
        });
      }
    },
    // getTobAllTask() {
    //   commonApi.getTobAllTask().then((res) => {
    //     if (res.code === 200) {
    //       this.nameOptions = res.data;
    //     }
    //   });
    // },
    // 获取问号中的显示内容
    getDic() {
      commonApi.getInfoToName({ name: "bktzkbzkbText" }).then((res) => {
        if (res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            if (item.key === "jsjyguljsy_text") {
              this.jsjyguljsy_text = item.value;
            }
          });
        }
      });
    },
    // 列表数据
    async queryTable(_type) {
      let params = deepClone(this.queryInfo);
      const res = await commonApi.getTobMarketing(params);
      if (res.code == 200) {
        this.queryInfo.total = res.data.total;
        this.tableList = res.data.list;
        this.allProgressData = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    // 分页
    handleSizeChange(e) {
      //  e);
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },
    resetQuery() {
      this.timeFrame = [];
      this.queryInfo = {
        limit: 10,
        page: 1,
        total: 0,
      };
      this.queryTable();
    },
    // 选择日期
    selectData(e) {
      if (e) {
        this.queryInfo.start_time = e[0];
        this.queryInfo.end_time = e[1];
      } else {
        this.queryInfo.start_time = "";
        this.queryInfo.end_time = "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin: 0 20px 10px 0;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 230px;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin: 10px 0;
    .el-button {
      margin: 0 5px 10px 0;
    }
  }

  // 表格数据
  //   .table {
  //     min-height: calc(100vh - 330px);
  //     border: 1px solid #ddd;
  //     border-radius: 10px;
  //     .studentLabel {
  //       display: inline-block;
  //       padding: 5px 10px;
  //       background-color: #409eff;
  //       color: #fff;
  //       border-radius: 4px;
  //       margin: 0 5px 5px 0;
  //     }
  //   }
  .operationItem {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: rgb(87, 87, 239);
  }
  .operationItem:hover {
    color: red;
  }

  /deep/ .formDialog {
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
  }
}

// 添加标签样式
/deep/ .editLabelClass {
  display: flex;
  align-items: flex-start;
  .p1 {
    margin-right: 20px;
    width: 70px;
    line-height: 30px;
  }
  .p2 {
    flex: 1;
  }
  .el-tag {
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .searchItem {
    .el-input {
      width: 200px;
      margin: 0 20px;
    }
  }
}
.editLabelClass + .editLabelClass {
  margin-top: 20px;
}
/deep/.el-input-number {
  width: 250px;
}

/deep/.noData {
  padding-top: 200px;
  .text {
    text-align: center;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .openClick {
    text-align: center;
  }
}

.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.flex-box {
  margin: 10px;
  display: flex;
  justify-content: space-around;
  //height: 80px;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 10px 10px 15px 10px;
}
.activeNumber {
  color: #f40;
}
.item_a1 {
  background-color: #f5f3ff;
}
.item_a2 {
  background-color: #edfffa;
}
.item_a3 {
  background-color: #fff6ed;
}
.item_a4 {
  background-color: #ffefef;
}
/deep/.el-dialog__footer {
  text-align: center;
}

.initialLogin {
  background: #ffebeb;
  border-radius: 8px 8px 8px 8px;
  line-height: 45px;
  padding: 0 20px 0 16px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  align-items: center;
  .initialLeft {
    color: #191b27;
    font-size: 15px;
    font-weight: 500;
  }
  .initialRight {
    height: 32px;
    width: 72px;
    background: linear-gradient(234deg, #ff6157 0%, #ff418a 100%);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    line-height: 32px;
    text-align: center;
    font-size: 13px;
    color: #ffffff;
    cursor: pointer;
  }
}

.questionIcon {
  width: 19px;
  height: 19px;
  background-image: url("../../assets/new/questionIcon_a1.png");
  background-size: 19px 19px;
  margin-top: -3px;
}
.questionIcon:hover {
  background-image: url("../../assets/new/questionIcon_a2.png");
  background-size: 19px 19px;
}
.initialNum {
  font-weight: bold;
  color: red;
  font-size: 20px;
  margin-bottom: 10px;
}
</style>
